import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RelatedPosts = ({ posts }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  if (!posts || posts?.length === 0) {
    return null;
  }

  return (
    <section className="border-t border-border pt-8 md:pt-10 lg:pt-12 mt-8 md:mt-10 lg:mt-12">
      <h2 className="text-xl font-semibold text-foreground mb-6 md:mb-8 lg:mb-10">
        Related Articles
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
        {posts?.map((post) => (
          <Link
            key={post?.id}
            to={`/blog-post-detail?slug=${post?.slug}`}
            className="group bg-card border border-border rounded-lg overflow-hidden transition-all duration-250 hover:shadow-glow hover:border-primary/50"
          >
            <div className="relative w-full h-48 md:h-56 lg:h-64 overflow-hidden">
              <Image
                src={post?.heroImage}
                alt={post?.heroImageAlt}
                className="w-full h-full object-cover transition-transform duration-250 group-hover:scale-105"
              />
            </div>
            
            <div className="p-4 md:p-5 lg:p-6 space-y-3 md:space-y-4">
              <div className="flex items-center gap-2 text-xs md:text-sm text-muted-foreground">
                <Icon name="Calendar" size={14} color="var(--color-primary)" />
                <time dateTime={post?.publishedAt}>{formatDate(post?.publishedAt)}</time>
              </div>
              
              <h3 className="text-base md:text-lg font-semibold text-foreground line-clamp-2 group-hover:text-primary transition-colors duration-250">
                {post?.title}
              </h3>
              
              <p className="text-sm md:text-base text-muted-foreground line-clamp-3">
                {post?.excerpt}
              </p>
              
              <div className="flex items-center gap-2 text-sm text-primary font-medium pt-2">
                <span>Read more</span>
                <Icon name="ArrowRight" size={16} color="var(--color-primary)" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedPosts;